import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { ResponsibleGamingUiConfigService } from "@obg/ngx.common";
import { CORE_ROUTE } from "@obg/ngx.core";
import { TelemetryService } from "@obg/ngx.global.evo";
import { Observable } from "rxjs";

import { DEPOSIT_LIMIT_EXCEEDED_URL } from "./deposit-limit-calculator-banner.const";
import { DepositLimitCalculatorBannerEvent } from "./deposit-limit-calculator-banner.model";

@Component({
	selector: "obg-m-deposit-limit-calculator-banner",
	templateUrl: "./deposit-limit-calculator-banner.html",
	styleUrls: ["./deposit-limit-calculator-banner.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class DepositLimitCalculatorBanner {
	depositCalculatorRoute = CORE_ROUTE.responsibleGaming.depositLimitCalculator;
	depositLimitImage = DEPOSIT_LIMIT_EXCEEDED_URL;
	isLimitCalculatorEnabled$: Observable<boolean | undefined> =
		this.responsibleGamingUiConfigService.getDepositLimitCalculatorEnabled$();

	constructor(
		private responsibleGamingUiConfigService: ResponsibleGamingUiConfigService,
		private telemetryService: TelemetryService
	) {}

	uiInteractionLinkClick() {
		this.telemetryService.track({
			event: DepositLimitCalculatorBannerEvent.LinkClick,
		});
	}
}
